
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/royalcollagenpeptides",
      function () {
        return require("private-next-pages/royalcollagenpeptides.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/royalcollagenpeptides"])
      });
    }
  